import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import CalendarTableList from "./CalendarTableList";
import { CalendarServices } from "./CalendarServices";
import Swal from "sweetalert2";

const ModalCustomCalendar = (props) => {
  const [showCreateCalendar, setShowCreateCalendar] = useState(false);
  const [calendars, setCalendars] = useState([])

  const loadCalendar = async () => {
    try {
      const result = await CalendarServices.getCalendarByOrganzation();
      const defaultCalendar =  [{Nombre:"Default",IdCalendario:null,Creador:"Default", ModificadoPor:"Default"}]
      setCalendars((prev)=>{
        return [...defaultCalendar,...result]
      });
    } catch (error) {
      Swal.fire("Error", error.message, "error");
    }
  };

  const handleChangeCalendar = async (IdCalendar) => {
    const nameCale = calendars.filter(cal => cal.IdCalendario == IdCalendar )[0]?.Nombre ? calendars.filter(cal => cal.IdCalendario == IdCalendar )[0].Nombre : "Default"
    const IdCalendarSele = (IdCalendar == "Default")? null : IdCalendar
    const result = await Swal.fire({
      title: "¿Estás seguro?",
      text: `Al cambiar al  calendario: ${nameCale}, afectara todas las actividades de su proyecto`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sí, Cambiar",
      cancelButtonText: "Cancelar",
    });

    if (result.isConfirmed) {
      const result = await CalendarServices.updateProjectCalendarId(props.idProject,IdCalendarSele);

      if (result.status) {
        Swal.fire(
          "¡Actualizado",
          "El calendario ha sido selecionado exitosamente",
          "success"
        ).then((val) => {
          if (val.isConfirmed) {
            props.gantt.clearAll();
            window.location.reload();
          }
        });
      }
    }
  };

  useEffect(() => {
    if(props.show){
      loadCalendar();
    }
  }, [props.show]);

  const calenderSelecter = ()=>{
    const calendarName = calendars.filter((cal)=>{
      return cal.IdCalendario == props.idCalendario
    })
    return {id:calendarName[0]?.IdCalendario, nameCalendar:calendarName[0]?.Nombre }
  }
    
  return (
    <>
      <Modal
        show={props.show}
        backdrop="static"
        size="xl"
        className={`${showCreateCalendar ? "modal-custom-calendar" : ""}`}
      >
        <Modal.Header className="py-3 d-flex justify-content-between">
          <h5 className="mb-0">Calendarios de la Organización</h5>
          <Button
            onClick={(e) => {
              props.setShow(false);
            }}
            variant="light"
          >
            X
          </Button>
        </Modal.Header>
        <Modal.Body>
          <p>Tienes seleccionado el Calendario : <b> {calenderSelecter().nameCalendar} </b></p>
          <Form.Label>Seleccione Calendario:</Form.Label>

          {calendars.length > 0 ? (
            <Form.Control
              style={{
                borderColor: "#343a40",
                backgroundColor: "transparent",
                color: "#343a40",
                width: "350px",
              }}
              as="select"
              onChange={(e) => {
                console.log("entra show");
                console.log(e.target.value);
                if(e.target.value != 0){
                  handleChangeCalendar(e.target.value);
                }
              }}
            >
                 <option value="0">Calendarios disponibles...</option>
              {calendars?.map((calendar, idx) => {
                return (
                  <option key={idx} value={calendar.IdCalendario}>
                    {calendar.Nombre}
                  </option>
                );
              })}
            </Form.Control>
          ) : (
            <>
              <br />
              <span>
                Aún no tienes calendarios creados. Estas usando el calendario
                por defecto.
              </span>
            </>
          )}

          <CalendarTableList
            show={showCreateCalendar}
            setShow={setShowCreateCalendar}
            calendars={calendars?.filter((cale)=> cale.IdCalendario !== null )}
            setCalendars={setCalendars}
            loadCaledar={loadCalendar}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalCustomCalendar;
